module.exports = __webpack_public_path__ + "static/media/mobile7.6ddae8e8.png";